import { InstallmentsOptions, SceneWrapper, SectionTitle } from '~/components';
import { currencyParser } from '~/modules';
import { CreditValue, CreditValueLabel, UpperSection } from './styles';

type CreditSimulationInstallmentsProps = {
  requestedCreditSimulationValue: number;
  simulationPlans: SimulationPlans[];
  handleInstallmentOptionSelect: (simulationPlan: SimulationPlans) => void;
};

const CreditSimulationInstallments = ({
  requestedCreditSimulationValue,
  simulationPlans,
  handleInstallmentOptionSelect,
}: CreditSimulationInstallmentsProps) => {
  return (
    <SceneWrapper>
      <UpperSection>
        <CreditValueLabel>Solicitado</CreditValueLabel>
        <CreditValue>
          {currencyParser(requestedCreditSimulationValue || 0)}
        </CreditValue>
      </UpperSection>
      <SectionTitle>Selecione o número de parcelas</SectionTitle>
      <InstallmentsOptions
        simulationPlans={simulationPlans}
        onOptionSelected={handleInstallmentOptionSelect}
      />
    </SceneWrapper>
  );
};

export default CreditSimulationInstallments;
